/**
 * Shared look for the Center Setup list editors (z8nrz7f0vu).
 *
 * The lists are edited in place, but they should read as a clean table, not a
 * spreadsheet of boxes: inputs carry no border until you point at or focus
 * them, rows separate with a hairline, and destructive icons stay muted until
 * hovered. The add row is the one place inputs look like a form.
 */

/** An inline cell input: invisible chrome until hover or focus. */
export const QUIET_INPUT =
  'h-8 border-transparent bg-transparent px-2 text-sm shadow-none transition-colors ' +
  'hover:border-input focus-visible:border-input focus-visible:bg-background ' +
  'read-only:hover:border-transparent'

/** The add row's inputs: a normal, visible field. */
export const FORM_INPUT = 'h-8 bg-background px-2 text-sm'

/** Column header text. */
export const HEADER_CELL = 'px-2 text-xs font-medium text-muted-foreground'

/** A list row. */
export const ROW = 'rounded-md py-1 transition-colors hover:bg-muted/50'

/** The muted delete icon button that turns red on hover. */
export const DELETE_BUTTON =
  'h-7 w-7 p-0 text-muted-foreground/70 hover:bg-destructive/10 hover:text-destructive'

/** The add row's container. */
export const ADD_ROW = 'mt-2 rounded-lg border border-dashed bg-muted/30 py-2'
